/*
 * rkm 2026-10-23 – Frische Lieferzeit (Fall RK-37831: Tab vor einer Bestandskorrektur geöffnet, 90 Min. später
 * „Sofort verfügbar“ in den Warenkorb gelegt, obwohl der Bestand schon 0 war).
 *
 * 1. Klick auf „In den Warenkorb“: vor dem Absenden wird der Status der gewählten Variante frisch geholt
 *    (/products/<handle>?view=rk-lz) und die versteckten Eigenschaften Lieferzeit/_rk_status werden nachgezogen.
 *    Antwortet der Server nicht binnen 2,5 s, wird normal abgeschickt.
 * 2. Warenkorb: beim Laden jeder Seite (höchstens alle 60 s) und beim Öffnen des Mini-Warenkorbs wird jede
 *    Position mit _rk_status gegen den frischen Status geprüft; Abweichungen werden per /cart/change.js korrigiert.
 *    „ausverkauft“ bleibt unangetastet (das blockiert Shopify im Checkout selbst).
 * 2b. (28.10.) Positionen ganz ohne _rk_status (z. B. über den Block „Passende Pflege“ in den Warenkorb gelegt) bekommen
 *    Status + Lieferzeit nach derselben Regel nachgetragen. Gutscheine und nicht versandpflichtige Positionen bleiben unberührt.
 * 3. Webyze-Konfigurator (27.10., Kundinnen ohne Lieferzeit im Warenkorb/Checkout/Bestellbestätigung): Webyze legt ein
 *    Temp-Produkt „Konfigurator<Grundtitel>“ am Theme-Formular vorbei in den Warenkorb, ohne Lieferzeit/_rk_status.
 *    Solche Positionen bekommen beide Eigenschaften nachgetragen: Status „konfigurator“, Dauer vom Grundprodukt
 *    (Titel = Grundtitel; Handle aus dem zuletzt besuchten Konfigurator, sonst Shop-Suche), sonst Gruppenwert.
 * Regeln: snippets/rk-lz-map.liquid (gleiche Quelle wie die Lieferzeit-Karte).
 */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cache = {};

  function fetchFresh(handle) {
    if (cache[handle] && Date.now() - cache[handle].t < 15000) return Promise.resolve(cache[handle].d);
    return fetch(root + 'products/' + encodeURIComponent(handle) + '?view=rk-lz&_=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('rk-lz ' + r.status); return r.text(); })
      .then(function (t) { var d = JSON.parse(t); cache[handle] = { t: Date.now(), d: d }; return d; });
  }

  function propText(data, key) {
    var st = data.statuses[key] || data.statuses.lager; if (!st) return null;
    var t = st.text || '';
    var oVon = parseInt(data.oVon, 10), oBis = parseInt(data.oBis, 10);
    if ((!isNaN(oVon) || !isNaN(oBis)) && key !== 'ausverkauft' && key !== 'vorbestellung') {
      var a = !isNaN(oVon) ? oVon : (parseInt(st.von, 10) || 0), b = !isNaN(oBis) ? oBis : (parseInt(st.bis, 10) || a);
      var re = /\d+\s*[–-]\s*\d+|\d+/; if (re.test(t)) t = t.replace(re, a === b ? String(a) : (a + '–' + b));
    }
    return (st.titel || '') + (t ? ' · ' + t : '');
  }

  function withTimeout(p, ms) {
    return Promise.race([p, new Promise(function (_, rej) { setTimeout(function () { rej(new Error('timeout')); }, ms); })]);
  }

  /* ---------- Webyze-Konfigurator: Grundprodukt finden ---------- */
  var KONF_KEY = 'rk-konf-base';
  var norm = function (t) { return String(t || '').replace(/\s+/g, ' ').trim().toLowerCase(); };
  function isWebyze(i) { return /^konfigurator\S/i.test(i.product_title || '') || !!(i.properties && i.properties['Product Preview']); }
  function rememberBase() {
    // Auf einer Produktseite mit Lieferzeit-Karte: Titel → Handle merken (Webyze-Temp-Produkte tragen den Grundtitel)
    var lz = document.querySelector('rk-lieferzeit[data-handle]');
    var og = document.querySelector('meta[property="og:title"]');
    if (!lz || !og || /^webyze-user-product/.test(lz.getAttribute('data-handle'))) return;
    try { var m = JSON.parse(sessionStorage.getItem(KONF_KEY) || '{}'); m[norm(og.content)] = lz.getAttribute('data-handle'); sessionStorage.setItem(KONF_KEY, JSON.stringify(m)); } catch (e) { /* ohne Storage → Suche */ }
  }
  function findBaseHandle(baseTitle) {
    var want = norm(baseTitle);
    try { var m = JSON.parse(sessionStorage.getItem(KONF_KEY) || '{}'); if (m[want]) return Promise.resolve(m[want]); } catch (e) { /* weiter */ }
    return fetch(root + 'search/suggest.json?q=' + encodeURIComponent(baseTitle) + '&resources[type]=product&resources[limit]=10', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        var hit = list.filter(function (p) { return norm(p.title) === want && !/^webyze-user-product/.test(p.handle); })[0];
        return hit ? hit.handle : null;
      }).catch(function () { return null; });
  }
  function konfFix(i) {
    var baseTitle = String(i.product_title || '').replace(/^konfigurator/i, '').trim();
    return findBaseHandle(baseTitle).then(function (h) { return h ? fetchFresh(h).catch(function () { return null; }) : null; })
      .then(function (d) { return d || fetchFresh(i.handle).catch(function () { return null; }); })
      .then(function (d) {
        if (!d || !d.statuses || !d.statuses.konfigurator) return null;
        var txt = propText(d, 'konfigurator'); if (!txt) return null;
        var props = {}; Object.keys(i.properties || {}).forEach(function (k) { props[k] = i.properties[k]; });
        props.Lieferzeit = txt; props._rk_status = 'konfigurator';
        return { id: i.key, quantity: i.quantity, properties: props };
      });
  }

  /* ---------- 1. Klick auf „In den Warenkorb“ ---------- */
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.id) return;
    var propS = document.querySelector('input[data-rk-lz-prop-status][form="' + form.id + '"]');
    if (!propS) return;
    if (form.getAttribute('data-rk-lz-fresh') === '1') { form.removeAttribute('data-rk-lz-fresh'); return; }
    var lz = propS.closest('rk-lieferzeit'); var handle = lz && lz.getAttribute('data-handle');
    var idInput = form.querySelector('[name="id"]'); var vid = idInput && idInput.value;
    if (!handle || !vid) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    var submitter = ev.submitter || null;
    var resend = function () {
      form.setAttribute('data-rk-lz-fresh', '1');
      if (form.requestSubmit) { try { form.requestSubmit(submitter && submitter.form === form ? submitter : undefined); return; } catch (e) { /* weiter */ } }
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    };
    withTimeout(fetchFresh(handle), 2500).then(function (data) {
      var key = data.map[String(vid)];
      if (key && key !== propS.value) {
        if (lz.rkMap) lz.rkMap[String(vid)] = key;
        if (typeof lz.rkRender === 'function') lz.rkRender(key, key !== 'ausverkauft');
        var prop = lz.querySelector('[data-rk-lz-prop]'); var txt = propText(data, key);
        if (prop && txt) prop.value = txt;
        propS.value = key;
      }
    }).catch(function () { /* Netzproblem: mit bekanntem Stand abschicken */ }).then(resend);
  }, true);

  /* ---------- 2. Warenkorb prüfen ---------- */
  var running = false;
  function checkCart(force) {
    if (running) return;
    try {
      var last = parseInt(sessionStorage.getItem('rk-lz-cart-check') || '0', 10);
      if (!force && !/\/cart\/?$/.test(location.pathname) && Date.now() - last < 60000) return;
      sessionStorage.setItem('rk-lz-cart-check', String(Date.now()));
    } catch (e) { /* ohne Storage einfach prüfen */ }
    running = true;
    fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      // (28.10.) Webyze legt sein Temp-Produkt manchmal in den Warenkorb, bevor der Preis gesetzt ist → 0 € („Kostenlos!“,
      // Summe ohne Jacke). Neu hinzufügen holt den inzwischen gesetzten Preis. Je Variante höchstens 2 Versuche pro Sitzung.
      var test = /[?&]rkwz=0/.test(location.search);
      var zero = (cart.items || []).filter(function (i) {
        if (!isWebyze(i) || !(i.original_price === 0 || test)) return false;
        var k = 'rk-wz-reprice-' + i.variant_id, n = 0;
        try { n = parseInt(sessionStorage.getItem(k) || '0', 10); sessionStorage.setItem(k, String(n + 1)); } catch (e) { n = 0; }
        return n < 2;
      });
      if (zero.length) {
        return zero.reduce(function (p, i) {
          return p.then(function () {
            return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: i.key, quantity: 0 }) })
              .then(function () { return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: i.variant_id, quantity: i.quantity, properties: i.properties || {} }] }) }); });
          });
        }, Promise.resolve()).then(function () {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (/\/cart\/?$/.test(location.pathname)) location.reload();
        });
      }
      // Webyze-Positionen nie über das Temp-Produkt prüfen (ohne Bestand/Kennung → wäre „lager“ = „Sofort verfügbar“)
      // Alle übrigen versandpflichtigen Positionen: mit Status → prüfen; ohne Status (z. B. „Passende Pflege“, Apps) → nachtragen
      var items = (cart.items || []).filter(function (i) { return i.handle && !isWebyze(i) && !i.gift_card && i.requires_shipping !== false; });
      var konf = (cart.items || []).filter(function (i) { return isWebyze(i) && !(i.properties && i.properties._rk_status === 'konfigurator'); });
      if (!items.length && !konf.length) return;
      var handles = items.map(function (i) { return i.handle; }).filter(function (h, n, a) { return a.indexOf(h) === n; });
      return Promise.all(handles.map(function (h) { return fetchFresh(h).catch(function () { return null; }); }).concat(konf.map(konfFix))).then(function (list) {
        var byHandle = {}; handles.forEach(function (h, n) { byHandle[h] = list[n]; });
        var fixes = list.slice(handles.length).filter(Boolean);
        items.forEach(function (i) {
          var d = byHandle[i.handle]; if (!d) return;
          var key = d.map[String(i.variant_id)];
          var cur = i.properties && i.properties._rk_status;
          if (!key || key === 'ausverkauft' || key === cur) return;
          var props = {}; Object.keys(i.properties || {}).forEach(function (k) { props[k] = i.properties[k]; });
          var txt = propText(d, key); if (txt) props.Lieferzeit = txt;
          props._rk_status = key;
          fixes.push({ id: i.key, quantity: i.quantity, properties: props });
        });
        if (!fixes.length) return;
        var okCount = 0;
        return fixes.reduce(function (p, f) {
          return p.then(function () { return fetch(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(f) }).then(function (r) { if (r.ok) okCount++; }); });
        }, Promise.resolve()).then(function () {
          if (!okCount) return;
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          // Warenkorbseite neu laden – höchstens einmal je 15 s (keine Schleife, falls eine Änderung nicht greift)
          var lastReload = 0; try { lastReload = parseInt(sessionStorage.getItem('rk-lz-reload') || '0', 10); sessionStorage.setItem('rk-lz-reload', String(Date.now())); } catch (e) { lastReload = Date.now(); }
          if (/\/cart\/?$/.test(location.pathname) && Date.now() - lastReload > 15000) location.reload();
        });
      });
    }).catch(function () { /* still */ }).then(function () { running = false; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { rememberBase(); checkCart(false); });
  else { rememberBase(); checkCart(false); }

  // Mini-Warenkorb geöffnet → frisch prüfen
  var watchDrawer = function () {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.hasAttribute('data-rk-lz-watch')) return;
    drawer.setAttribute('data-rk-lz-watch', '1');
    new MutationObserver(function () { if (drawer.hasAttribute('open')) checkCart(true); }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
})();
